import React, { useState, useEffect } from "react";
import {
    MDBTable,
    MDBTableHead,
    MDBTableBody
} from 'mdb-react-ui-kit';
import { Row, Col, Breadcrumb, Card, Form } from 'react-bootstrap';
import { InputText } from "primereact/inputtext";
import { Button } from 'primereact/button';
import { Link } from "react-router-dom";
import { InputIcon } from "primereact/inputicon";
import { IconField } from "primereact/iconfield";
import axios from 'axios';
import { useAuth } from '../context/AuthContext';
import config from '../config';
import { Badge } from 'primereact/badge';

const Sendinvoice = () => {
    const { accessToken } = useAuth();
    const [pdfDocs, setPdfDocs] = useState([]);
    const [loading, setLoading] = useState(false);


    // Fetch PDF Documents
    const fetchPdfDocuments = async () => {
        setLoading(true);
        try {
            const response = await axios.get(`${config.apiBASEURL}/InvoiceRoutes/pdf-documents`, {
                headers: { Authorization: `Bearer ${accessToken}` },
            });
            setPdfDocs(response.data.data || []);
        } catch (error) {
            console.error("Error fetching PDF documents:", error);
        }
        setLoading(false);
    };

    useEffect(() => {
        if (accessToken) {
            fetchPdfDocuments();
        }
    }, [accessToken]);
    return (
        <>
            <Row className="mx-0 justify-content-end pb-4 align-items-center">
                {/* <Col lg={6} className='d-flex justify-content-end align-items-end'>
                    <div>
                        <IconField iconPosition="left" className='me-2'>
                            <InputIcon className="pi pi-search" />
                            <InputText
                                value={templateName}
                                onChange={(e) => setTemplateName(e.target.value)}
                                placeholder=" Template Name"
                                className='border-0 border-bottom ps-5'
                                style={{ width: '180px' }}
                            />
                        </IconField>
                    </div>
                    <div>
                        <IconField iconPosition="left" className='me-2'>
                            <InputIcon className="pi pi-search" />
                            <InputText
                                value={billingName}
                                onChange={(e) => setBillingName(e.target.value)}
                                placeholder="Billing Name"
                                className='border-0 border-bottom ps-5'
                                style={{ width: '180px' }}
                            />
                        </IconField>
                    </div>
                    <div>
                        <Form.Select
                            value={financialYear}
                            onChange={(e) => setFinancialYear(e.target.value)}
                            className='border-0 border-bottom '
                            style={{ width: '180px' }}
                        >
                            <option value="">Select Year</option>
                            <option value="29-30">2029-2030</option>
                            <option value="28-29">2028-2029</option>
                            <option value="27-28">2027-2028</option>
                            <option value="26-27">2026-2027</option>
                            <option value="25-26">2025-2026</option>
                            <option value="24-25">2024-2025</option>
                            <option value="23-24">2023-2024</option>
                            <option value="22-23">2022-2023</option>
                        </Form.Select>
                    </div>
                </Col> */}
            </Row>
            <div>
                <MDBTable responsive hover className="Departtable">
                    <MDBTableHead className="sticky-top" style={{ backgroundColor: "#e1ebff" }}>
                        <tr>
                            <th scope='col'>PDF Id</th>
                            <th scope='col'>Download link</th>
                            <th scope='col' style={{ width: '250px' }}>Invoice ID's</th>
                            <th scope='col' style={{ width: '250px' }}>Invoice Details</th>
                            <th scope='col'>Deletion Date</th>
                        </tr>
                    </MDBTableHead>
                    <MDBTableBody>
                        {loading ? (
                            <tr>
                                <td colSpan="9" className="text-center">Loading...</td>
                            </tr>
                        ) : pdfDocs.length === 0 ? (
                            <tr>
                                <td colSpan="9" className="text-center">No PDFs for downloading found</td>
                            </tr>
                        ) : (
                            pdfDocs.map((invoice) => (
                                <tr key={invoice.Pdf_Document_id}>
                                    <td>{invoice.Pdf_Document_id}</td>
                                    <td>
                                        {/* {invoice.billing_name && (
                                            <p className="m-0">
                                                <small>Billing Name: </small>
                                                 <b>{invoice.billing_name}</b>
                                            </p>
                                        )} */}

                                        {/* {invoice.template_name && (
                                            <p className="m-0">
                                                <small>Invoice Code:  <b>{invoice.template_name}</b></small>
                                            </p>
                                        )} */}

                                        <a href={invoice.Pdf_url} target="_blank" rel="noopener noreferrer">
                                            {invoice.Pdf_url}
                                        </a>
                                    </td>
                                    <td>
                                        {Array.isArray(invoice.invoice_code) &&
                                            invoice.invoice_code.map((code, index) => (
                                                <span className="alldateSpan" key={index}>
                                                    {code}
                                                    {index < invoice.invoice_code.length - 1 }
                                                </span>
                                            ))}
                                    </td>
                                    <td>
                                        <p className="m-0"><small>Financial Year:{invoice.financial_year || 'NA'}</small></p>
                                        <p className="m-0 "><small className="d-block">Client Details:</small></p>
                                         {Array.isArray(invoice.client_name) &&
                                            invoice.client_name.map((code, index) => (
                                                <span className="alldateSpan" key={index}>
                                                    {code}
                                                    {index < invoice.client_name.length - 1 }
                                                </span>
                                            ))}
                                    </td>

                                    <td>
                                        <p className="m-0"><small> </small> <b> {new Date(invoice.removal_date).toLocaleDateString('en-GB')}</b></p>
                                    </td>
                                </tr>
                            ))
                        )}
                    </MDBTableBody>
                </MDBTable>
            </div>
        </>
    );
};

export default Sendinvoice;
